const apiService = {
    api: document.location.protocol + '//www.hn-ihealth.com',
    api_http: document.location.protocol + '//www.hn-ihealth.com',
    api_app_download: 'http://apps.hn-ihealth.com',
}
export default apiService;